const state = {
  pfDocs: [],
  pfDocsSection: {},
  pfCandidates: {},
  currPage: 1,
  pageCount: 1,
  pfActivityCount: 0,
}

export default state
